import { observable, action } from 'mobx';
import { request } from 'utils/api';
import BaseStore from './BaseStore';

const META_TYPE = 'interesttopic';

export default class InterestTopicsStore extends BaseStore {
  @observable items = [];

  @action
  fetchItems(statusKey = 'list') {
    const status = this.createStatus(statusKey);
    return request({
      method: 'GET',
      path: `/1/metadata/${META_TYPE}`,
    })
      .then(({ data }) => {
        this.items.replace(data);
        status.success();
        return data;
      })
      .catch((err) => {
        status.error(err);
        return err;
      });
  }

  @action
  create({ name, order }, statusKey = 'create') {
    const status = this.createStatus(statusKey);
    return request({
      method: 'POST',
      path: `/1/metadata/${META_TYPE}`,
      body: { type: META_TYPE, name, order },
    })
      .then(({ data }) => {
        return this.fetchItems(false).then(() => {
          status.success();
          return data;
        });
      })
      .catch((err) => {
        status.error(err);
        return err;
      });
  }

  @action
  update({ id, name, order }, statusKey = 'update') {
    const status = this.createStatus(statusKey);
    return request({
      method: 'PATCH',
      path: `/1/metadata/${id}`,
      body: { type: META_TYPE, name, order },
    })
      .then(() => {
        return this.fetchItems(false).then(() => {
          status.success();
        });
      })
      .catch((err) => {
        status.error(err);
        return err;
      });
  }

  @action
  delete(item, statusKey = 'delete') {
    const status = this.createStatus(statusKey);
    return request({
      method: 'DELETE',
      path: `/1/metadata/${item.id}`,
    })
      .then(() => {
        return this.fetchItems(false).then(() => {
          status.success();
        });
      })
      .catch((err) => {
        status.error(err);
        return err;
      });
  }
}
